import { IJwtMember } from "@/v2/types/Auth/IJwtMember.interface";
import { OWNER_ROLE } from "@/v2/utils/constants";

import { clearPersistedImpersonation } from "./clearPersistedImpersonation";
import { readPersistedImpersonation } from "./readPersistedImpersonation";

/**
 * Decides whether a persisted impersonation may be restored for `realUser`
 * (e.g. after a page reload).
 *
 * Restoration is allowed only when the real user is an owner and owns the
 * persisted token (`ownerSub === realUser.sub`); otherwise the stored entry is
 * cleared and `null` is returned. This prevents a non-owner from resuming
 * an impersonation session left in localStorage.
 */
export const resolveRestorableImpersonation = (
  realUser: IJwtMember,
): { user: IJwtMember; jwt: string } | null => {
  const persisted = readPersistedImpersonation();

  if (!persisted) return null;

  const realIsOwner = (realUser.roles ?? []).includes(OWNER_ROLE);
  const ownedByRealUser = persisted.ownerSub === realUser.sub;

  if (!realIsOwner || !ownedByRealUser) {
    clearPersistedImpersonation();
    return null;
  }

  return { user: persisted.user, jwt: persisted.jwt };
};
